export const cardScanPackageVersion = '4.0.21';
